import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className"],
  _excluded2 = ["title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/utils';
import { InfoBanner } from '@beef/smart-kit';
import { selectContainerData } from "../../../../store/blocks/addressVerification/selectors";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var _Container = function _Container(_ref) {
  var children = _ref.children,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('container', className),
    "data-t-id": "components-Container"
  }, /*#__PURE__*/React.createElement(InfoBanner, _extends({
    backgroundColor: "#f9f9f9",
    backgroundPosition: "right",
    backgroundSize: "auto 380px",
    textColor: "grey60"
  }, props), children));
};
var mapStateToProps = function mapStateToProps(state) {
  var _selectContainerData = selectContainerData(state),
    title = _selectContainerData.title,
    rest = _objectWithoutProperties(_selectContainerData, _excluded2);
  return _objectSpread({
    title: title,
    shouldRender: !!title
  }, rest);
};
var connector = connect(mapStateToProps);
export var Container = compose(connector, withRenderFlag)(_Container);